export const getCommonOdataOptions = ({ serverContext }) => {
  const {
    CurrentAccount: currentAccount,
    ServicesEndpoints: { CampaignAPI: host },
    CampaignAPIPath: path,
    Token: token,
    Urls: { SignOutUrl = null } = {},
  } = serverContext;

  return {
    cid: currentAccount ? currentAccount.AdvertiserCustomerID : '',
    aid: currentAccount ? currentAccount.Id : '',
    host,
    path,
    token,
    SignOutUrl,
  };
};
